export default __webpack_public_path__ + "static/media/hong-kong.df1f632f.png";